"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: user/family-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fuser%2Ffamily-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.FamilyServiceClient = exports.MergeFamilyMembersResponse = exports.MergeFamilyMembersRequest = exports.SwitchToMergedUserResponse = exports.SwitchToMergedUserRequest = exports.CreateManagedUserResponse = exports.CreateManagedUserRequest = exports.ImpersonateUserResponse = exports.ImpersonateUserRequest = exports.RemoveFamilyMemberResponse = exports.RemoveFamilyMemberRequest = exports.UpdateFamilyMemberResponse = exports.UpdateFamilyMemberRequest = exports.RejectFamilyInviteResponse = exports.RejectFamilyInviteRequest = exports.JoinFamilyResponse = exports.JoinFamilyRequest = exports.UnInviteMemberResponse = exports.UnInviteMemberRequest = exports.InviteMemberResponse = exports.InviteMemberRequest = exports.GetFamilyAddressResponse = exports.GetFamilyAddressRequest = exports.ApproveFamilyInviteResponse = exports.ApproveFamilyInviteRequest = exports.GetFamilyInvitesResponse = exports.GetFamilyInvitesRequest = exports.GetFamilyResponseSentInvite = exports.GetFamilyResponse = exports.GetFamilyRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const address_1 = require("../common/address");
const alias_1 = require("../common/alias");
const family_group_1 = require("../common/family-group");
const legal_name_1 = require("../common/legal-name");
const token_1 = require("../common/token");
const family_invite_info_1 = require("./family-invite-info");
const family_member_1 = require("./family-member");
const protobufPackage = 'com.step.user.proto';
function createBaseGetFamilyRequest() {
    return {};
}
exports.GetFamilyRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetFamilyRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetFamilyRequest();
        return message;
    },
};
function createBaseGetFamilyResponse() {
    return { members: [], invites: [] };
}
exports.GetFamilyResponse = {
    fromJSON(object) {
        const message = {
            members: globalThis.Array.isArray(object?.members)
                ? object.members.map((e) => family_member_1.FamilyMember.fromJSON(e))
                : [],
            invites: globalThis.Array.isArray(object?.invites)
                ? object.invites.map((e) => exports.GetFamilyResponseSentInvite.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.members?.length) {
            obj.members = message.members.map((e) => family_member_1.FamilyMember.toJSON(e));
        }
        if (message.invites?.length) {
            obj.invites = message.invites.map((e) => exports.GetFamilyResponseSentInvite.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetFamilyResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetFamilyResponse();
        message.members = object.members?.map((e) => family_member_1.FamilyMember.fromPartial(e)) || [];
        message.invites = object.invites?.map((e) => exports.GetFamilyResponseSentInvite.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetFamilyResponseSentInvite() {
    return {
        inviteeAlias: alias_1.Alias.fromPartial({}),
        group: family_group_1.FamilyGroup.FAMILY_INVALID,
        inviterUserId: '',
        timeMs: '0',
        needsApproval: false,
        managedUserId: '',
    };
}
exports.GetFamilyResponseSentInvite = {
    fromJSON(object) {
        const message = {
            inviteeAlias: isSet(object.inviteeAlias)
                ? alias_1.Alias.fromJSON(object.inviteeAlias)
                : alias_1.Alias.fromPartial({}),
            group: isSet(object.group) ? (0, family_group_1.familyGroupFromJSON)(object.group) : family_group_1.FamilyGroup.FAMILY_INVALID,
            inviterUserId: isSet(object.inviterUserId) ? globalThis.String(object.inviterUserId) : '',
            needsApproval: isSet(object.needsApproval) ? globalThis.Boolean(object.needsApproval) : false,
        };
        if (isSet(object.timeMs)) {
            message.timeMs = globalThis.String(object.timeMs);
        }
        if (isSet(object.managedUserId)) {
            message.managedUserId = globalThis.String(object.managedUserId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.inviteeAlias !== undefined) {
            obj.inviteeAlias = alias_1.Alias.toJSON(message.inviteeAlias);
        }
        if (message.group !== family_group_1.FamilyGroup.FAMILY_INVALID) {
            obj.group = (0, family_group_1.familyGroupToJSON)(message.group);
        }
        if (message.inviterUserId !== '') {
            obj.inviterUserId = message.inviterUserId;
        }
        if (message.timeMs !== undefined && message.timeMs !== '0') {
            obj.timeMs = message.timeMs;
        }
        if (message.needsApproval !== false) {
            obj.needsApproval = message.needsApproval;
        }
        if (message.managedUserId !== undefined && message.managedUserId !== '') {
            obj.managedUserId = message.managedUserId;
        }
        return obj;
    },
    create(base) {
        return exports.GetFamilyResponseSentInvite.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetFamilyResponseSentInvite();
        message.inviteeAlias = (object.inviteeAlias !== undefined && object.inviteeAlias !== null)
            ? alias_1.Alias.fromPartial(object.inviteeAlias)
            : alias_1.Alias.fromPartial({});
        message.group = object.group ?? family_group_1.FamilyGroup.FAMILY_INVALID;
        message.inviterUserId = object.inviterUserId ?? '';
        message.timeMs = object.timeMs ?? '0';
        message.needsApproval = object.needsApproval ?? false;
        message.managedUserId = object.managedUserId ?? '';
        return message;
    },
};
function createBaseGetFamilyInvitesRequest() {
    return {};
}
exports.GetFamilyInvitesRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetFamilyInvitesRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetFamilyInvitesRequest();
        return message;
    },
};
function createBaseGetFamilyInvitesResponse() {
    return { invites: [] };
}
exports.GetFamilyInvitesResponse = {
    fromJSON(object) {
        const message = {
            invites: globalThis.Array.isArray(object?.invites)
                ? object.invites.map((e) => family_invite_info_1.ReceivedInvite.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.invites?.length) {
            obj.invites = message.invites.map((e) => family_invite_info_1.ReceivedInvite.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetFamilyInvitesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetFamilyInvitesResponse();
        message.invites = object.invites?.map((e) => family_invite_info_1.ReceivedInvite.fromPartial(e)) || [];
        return message;
    },
};
function createBaseApproveFamilyInviteRequest() {
    return { inviteeAlias: alias_1.Alias.fromPartial({}) };
}
exports.ApproveFamilyInviteRequest = {
    fromJSON(object) {
        const message = {
            inviteeAlias: isSet(object.inviteeAlias)
                ? alias_1.Alias.fromJSON(object.inviteeAlias)
                : alias_1.Alias.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.inviteeAlias !== undefined) {
            obj.inviteeAlias = alias_1.Alias.toJSON(message.inviteeAlias);
        }
        return obj;
    },
    create(base) {
        return exports.ApproveFamilyInviteRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseApproveFamilyInviteRequest();
        message.inviteeAlias = (object.inviteeAlias !== undefined && object.inviteeAlias !== null)
            ? alias_1.Alias.fromPartial(object.inviteeAlias)
            : alias_1.Alias.fromPartial({});
        return message;
    },
};
function createBaseApproveFamilyInviteResponse() {
    return {};
}
exports.ApproveFamilyInviteResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ApproveFamilyInviteResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseApproveFamilyInviteResponse();
        return message;
    },
};
function createBaseGetFamilyAddressRequest() {
    return {};
}
exports.GetFamilyAddressRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetFamilyAddressRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetFamilyAddressRequest();
        return message;
    },
};
function createBaseGetFamilyAddressResponse() {
    return { address: undefined };
}
exports.GetFamilyAddressResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.address)) {
            message.address = address_1.Address.fromJSON(object.address);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.address !== undefined) {
            obj.address = address_1.Address.toJSON(message.address);
        }
        return obj;
    },
    create(base) {
        return exports.GetFamilyAddressResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetFamilyAddressResponse();
        message.address = (object.address !== undefined && object.address !== null)
            ? address_1.Address.fromPartial(object.address)
            : undefined;
        return message;
    },
};
function createBaseInviteMemberRequest() {
    return {
        inviteeAlias: alias_1.Alias.fromPartial({}),
        group: family_group_1.FamilyGroup.FAMILY_INVALID,
        managedUserId: '',
        sendSms: false,
    };
}
exports.InviteMemberRequest = {
    fromJSON(object) {
        const message = {
            inviteeAlias: isSet(object.inviteeAlias)
                ? alias_1.Alias.fromJSON(object.inviteeAlias)
                : alias_1.Alias.fromPartial({}),
            group: isSet(object.group) ? (0, family_group_1.familyGroupFromJSON)(object.group) : family_group_1.FamilyGroup.FAMILY_INVALID,
        };
        if (isSet(object.managedUserId)) {
            message.managedUserId = globalThis.String(object.managedUserId);
        }
        if (isSet(object.sendSms)) {
            message.sendSms = globalThis.Boolean(object.sendSms);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.inviteeAlias !== undefined) {
            obj.inviteeAlias = alias_1.Alias.toJSON(message.inviteeAlias);
        }
        if (message.group !== family_group_1.FamilyGroup.FAMILY_INVALID) {
            obj.group = (0, family_group_1.familyGroupToJSON)(message.group);
        }
        if (message.managedUserId !== undefined && message.managedUserId !== '') {
            obj.managedUserId = message.managedUserId;
        }
        if (message.sendSms !== undefined && message.sendSms !== false) {
            obj.sendSms = message.sendSms;
        }
        return obj;
    },
    create(base) {
        return exports.InviteMemberRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInviteMemberRequest();
        message.inviteeAlias = (object.inviteeAlias !== undefined && object.inviteeAlias !== null)
            ? alias_1.Alias.fromPartial(object.inviteeAlias)
            : alias_1.Alias.fromPartial({});
        message.group = object.group ?? family_group_1.FamilyGroup.FAMILY_INVALID;
        message.managedUserId = object.managedUserId ?? '';
        message.sendSms = object.sendSms ?? false;
        return message;
    },
};
function createBaseInviteMemberResponse() {
    return { inviteId: '' };
}
exports.InviteMemberResponse = {
    fromJSON(object) {
        const message = {
            inviteId: isSet(object.inviteId) ? globalThis.String(object.inviteId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.inviteId !== '') {
            obj.inviteId = message.inviteId;
        }
        return obj;
    },
    create(base) {
        return exports.InviteMemberResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInviteMemberResponse();
        message.inviteId = object.inviteId ?? '';
        return message;
    },
};
function createBaseUnInviteMemberRequest() {
    return { inviteeAlias: alias_1.Alias.fromPartial({}) };
}
exports.UnInviteMemberRequest = {
    fromJSON(object) {
        const message = {
            inviteeAlias: isSet(object.inviteeAlias)
                ? alias_1.Alias.fromJSON(object.inviteeAlias)
                : alias_1.Alias.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.inviteeAlias !== undefined) {
            obj.inviteeAlias = alias_1.Alias.toJSON(message.inviteeAlias);
        }
        return obj;
    },
    create(base) {
        return exports.UnInviteMemberRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnInviteMemberRequest();
        message.inviteeAlias = (object.inviteeAlias !== undefined && object.inviteeAlias !== null)
            ? alias_1.Alias.fromPartial(object.inviteeAlias)
            : alias_1.Alias.fromPartial({});
        return message;
    },
};
function createBaseUnInviteMemberResponse() {
    return {};
}
exports.UnInviteMemberResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UnInviteMemberResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUnInviteMemberResponse();
        return message;
    },
};
function createBaseJoinFamilyRequest() {
    return { familyId: '', managedUserId: '' };
}
exports.JoinFamilyRequest = {
    fromJSON(object) {
        const message = {
            familyId: isSet(object.familyId) ? globalThis.String(object.familyId) : '',
        };
        if (isSet(object.managedUserId)) {
            message.managedUserId = globalThis.String(object.managedUserId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.familyId !== '') {
            obj.familyId = message.familyId;
        }
        if (message.managedUserId !== undefined && message.managedUserId !== '') {
            obj.managedUserId = message.managedUserId;
        }
        return obj;
    },
    create(base) {
        return exports.JoinFamilyRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseJoinFamilyRequest();
        message.familyId = object.familyId ?? '';
        message.managedUserId = object.managedUserId ?? '';
        return message;
    },
};
function createBaseJoinFamilyResponse() {
    return {};
}
exports.JoinFamilyResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.JoinFamilyResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseJoinFamilyResponse();
        return message;
    },
};
function createBaseRejectFamilyInviteRequest() {
    return { familyId: '' };
}
exports.RejectFamilyInviteRequest = {
    fromJSON(object) {
        const message = {
            familyId: isSet(object.familyId) ? globalThis.String(object.familyId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.familyId !== '') {
            obj.familyId = message.familyId;
        }
        return obj;
    },
    create(base) {
        return exports.RejectFamilyInviteRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRejectFamilyInviteRequest();
        message.familyId = object.familyId ?? '';
        return message;
    },
};
function createBaseRejectFamilyInviteResponse() {
    return {};
}
exports.RejectFamilyInviteResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.RejectFamilyInviteResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseRejectFamilyInviteResponse();
        return message;
    },
};
function createBaseUpdateFamilyMemberRequest() {
    return { userToUpdateId: '', group: family_group_1.FamilyGroup.FAMILY_INVALID };
}
exports.UpdateFamilyMemberRequest = {
    fromJSON(object) {
        const message = {
            userToUpdateId: isSet(object.userToUpdateId) ? globalThis.String(object.userToUpdateId) : '',
            group: isSet(object.group) ? (0, family_group_1.familyGroupFromJSON)(object.group) : family_group_1.FamilyGroup.FAMILY_INVALID,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userToUpdateId !== '') {
            obj.userToUpdateId = message.userToUpdateId;
        }
        if (message.group !== family_group_1.FamilyGroup.FAMILY_INVALID) {
            obj.group = (0, family_group_1.familyGroupToJSON)(message.group);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateFamilyMemberRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateFamilyMemberRequest();
        message.userToUpdateId = object.userToUpdateId ?? '';
        message.group = object.group ?? family_group_1.FamilyGroup.FAMILY_INVALID;
        return message;
    },
};
function createBaseUpdateFamilyMemberResponse() {
    return { member: family_member_1.FamilyMember.fromPartial({}) };
}
exports.UpdateFamilyMemberResponse = {
    fromJSON(object) {
        const message = {
            member: isSet(object.member)
                ? family_member_1.FamilyMember.fromJSON(object.member)
                : family_member_1.FamilyMember.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.member !== undefined) {
            obj.member = family_member_1.FamilyMember.toJSON(message.member);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateFamilyMemberResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateFamilyMemberResponse();
        message.member = (object.member !== undefined && object.member !== null)
            ? family_member_1.FamilyMember.fromPartial(object.member)
            : family_member_1.FamilyMember.fromPartial({});
        return message;
    },
};
function createBaseRemoveFamilyMemberRequest() {
    return { userToRemoveId: '' };
}
exports.RemoveFamilyMemberRequest = {
    fromJSON(object) {
        const message = {
            userToRemoveId: isSet(object.userToRemoveId) ? globalThis.String(object.userToRemoveId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userToRemoveId !== '') {
            obj.userToRemoveId = message.userToRemoveId;
        }
        return obj;
    },
    create(base) {
        return exports.RemoveFamilyMemberRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRemoveFamilyMemberRequest();
        message.userToRemoveId = object.userToRemoveId ?? '';
        return message;
    },
};
function createBaseRemoveFamilyMemberResponse() {
    return {};
}
exports.RemoveFamilyMemberResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.RemoveFamilyMemberResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseRemoveFamilyMemberResponse();
        return message;
    },
};
function createBaseImpersonateUserRequest() {
    return { userId: '', sessionLifetimeMs: '0' };
}
exports.ImpersonateUserRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            sessionLifetimeMs: isSet(object.sessionLifetimeMs)
                ? globalThis.String(object.sessionLifetimeMs)
                : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.sessionLifetimeMs !== '0') {
            obj.sessionLifetimeMs = message.sessionLifetimeMs;
        }
        return obj;
    },
    create(base) {
        return exports.ImpersonateUserRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseImpersonateUserRequest();
        message.userId = object.userId ?? '';
        message.sessionLifetimeMs = object.sessionLifetimeMs ?? '0';
        return message;
    },
};
function createBaseImpersonateUserResponse() {
    return {
        userId: '',
        refreshToken: token_1.AuthToken.fromPartial({}),
        accessToken: token_1.AuthToken.fromPartial({}),
    };
}
exports.ImpersonateUserResponse = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            refreshToken: isSet(object.refreshToken)
                ? token_1.AuthToken.fromJSON(object.refreshToken)
                : token_1.AuthToken.fromPartial({}),
            accessToken: isSet(object.accessToken)
                ? token_1.AuthToken.fromJSON(object.accessToken)
                : token_1.AuthToken.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.refreshToken !== undefined) {
            obj.refreshToken = token_1.AuthToken.toJSON(message.refreshToken);
        }
        if (message.accessToken !== undefined) {
            obj.accessToken = token_1.AuthToken.toJSON(message.accessToken);
        }
        return obj;
    },
    create(base) {
        return exports.ImpersonateUserResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseImpersonateUserResponse();
        message.userId = object.userId ?? '';
        message.refreshToken = (object.refreshToken !== undefined && object.refreshToken !== null)
            ? token_1.AuthToken.fromPartial(object.refreshToken)
            : token_1.AuthToken.fromPartial({});
        message.accessToken = (object.accessToken !== undefined && object.accessToken !== null)
            ? token_1.AuthToken.fromPartial(object.accessToken)
            : token_1.AuthToken.fromPartial({});
        return message;
    },
};
function createBaseCreateManagedUserRequest() {
    return { dob: '', legalName: legal_name_1.LegalName.fromPartial({}) };
}
exports.CreateManagedUserRequest = {
    fromJSON(object) {
        const message = {
            dob: isSet(object.dob) ? globalThis.String(object.dob) : '',
            legalName: isSet(object.legalName)
                ? legal_name_1.LegalName.fromJSON(object.legalName)
                : legal_name_1.LegalName.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.dob !== '') {
            obj.dob = message.dob;
        }
        if (message.legalName !== undefined) {
            obj.legalName = legal_name_1.LegalName.toJSON(message.legalName);
        }
        return obj;
    },
    create(base) {
        return exports.CreateManagedUserRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateManagedUserRequest();
        message.dob = object.dob ?? '';
        message.legalName = (object.legalName !== undefined && object.legalName !== null)
            ? legal_name_1.LegalName.fromPartial(object.legalName)
            : legal_name_1.LegalName.fromPartial({});
        return message;
    },
};
function createBaseCreateManagedUserResponse() {
    return { userId: '' };
}
exports.CreateManagedUserResponse = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        return obj;
    },
    create(base) {
        return exports.CreateManagedUserResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateManagedUserResponse();
        message.userId = object.userId ?? '';
        return message;
    },
};
function createBaseSwitchToMergedUserRequest() {
    return { sessionLifetimeMs: '0' };
}
exports.SwitchToMergedUserRequest = {
    fromJSON(object) {
        const message = {
            sessionLifetimeMs: isSet(object.sessionLifetimeMs)
                ? globalThis.String(object.sessionLifetimeMs)
                : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sessionLifetimeMs !== '0') {
            obj.sessionLifetimeMs = message.sessionLifetimeMs;
        }
        return obj;
    },
    create(base) {
        return exports.SwitchToMergedUserRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSwitchToMergedUserRequest();
        message.sessionLifetimeMs = object.sessionLifetimeMs ?? '0';
        return message;
    },
};
function createBaseSwitchToMergedUserResponse() {
    return {
        userId: '',
        refreshToken: token_1.AuthToken.fromPartial({}),
        accessToken: token_1.AuthToken.fromPartial({}),
    };
}
exports.SwitchToMergedUserResponse = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            refreshToken: isSet(object.refreshToken)
                ? token_1.AuthToken.fromJSON(object.refreshToken)
                : token_1.AuthToken.fromPartial({}),
            accessToken: isSet(object.accessToken)
                ? token_1.AuthToken.fromJSON(object.accessToken)
                : token_1.AuthToken.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.refreshToken !== undefined) {
            obj.refreshToken = token_1.AuthToken.toJSON(message.refreshToken);
        }
        if (message.accessToken !== undefined) {
            obj.accessToken = token_1.AuthToken.toJSON(message.accessToken);
        }
        return obj;
    },
    create(base) {
        return exports.SwitchToMergedUserResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSwitchToMergedUserResponse();
        message.userId = object.userId ?? '';
        message.refreshToken = (object.refreshToken !== undefined && object.refreshToken !== null)
            ? token_1.AuthToken.fromPartial(object.refreshToken)
            : token_1.AuthToken.fromPartial({});
        message.accessToken = (object.accessToken !== undefined && object.accessToken !== null)
            ? token_1.AuthToken.fromPartial(object.accessToken)
            : token_1.AuthToken.fromPartial({});
        return message;
    },
};
function createBaseMergeFamilyMembersRequest() {
    return { fromUserId: '', managedUserId: '' };
}
exports.MergeFamilyMembersRequest = {
    fromJSON(object) {
        const message = {
            fromUserId: isSet(object.fromUserId) ? globalThis.String(object.fromUserId) : '',
            managedUserId: isSet(object.managedUserId) ? globalThis.String(object.managedUserId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.fromUserId !== '') {
            obj.fromUserId = message.fromUserId;
        }
        if (message.managedUserId !== '') {
            obj.managedUserId = message.managedUserId;
        }
        return obj;
    },
    create(base) {
        return exports.MergeFamilyMembersRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMergeFamilyMembersRequest();
        message.fromUserId = object.fromUserId ?? '';
        message.managedUserId = object.managedUserId ?? '';
        return message;
    },
};
function createBaseMergeFamilyMembersResponse() {
    return {};
}
exports.MergeFamilyMembersResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.MergeFamilyMembersResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseMergeFamilyMembersResponse();
        return message;
    },
};
/**
 * Family management API.
 *
 * Manages family membership. Multiple members can be assigned admin role
 * (parents).
 */
class FamilyServiceClient {
    rpc;
    name = 'com.step.user.proto.FamilyService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/family';
    methods = [{
            name: 'Get',
            requestType: exports.GetFamilyRequest,
            responseType: exports.GetFamilyResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetFamilyInvites',
            requestType: exports.GetFamilyInvitesRequest,
            responseType: exports.GetFamilyInvitesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetFamilyAddress',
            requestType: exports.GetFamilyAddressRequest,
            responseType: exports.GetFamilyAddressResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'InviteMember',
            requestType: exports.InviteMemberRequest,
            responseType: exports.InviteMemberResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'ApproveFamilyInvite',
            requestType: exports.ApproveFamilyInviteRequest,
            responseType: exports.ApproveFamilyInviteResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'UnInviteMember',
            requestType: exports.UnInviteMemberRequest,
            responseType: exports.UnInviteMemberResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'JoinFamily',
            requestType: exports.JoinFamilyRequest,
            responseType: exports.JoinFamilyResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'RejectFamilyInvite',
            requestType: exports.RejectFamilyInviteRequest,
            responseType: exports.RejectFamilyInviteResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'UpdateFamilyMember',
            requestType: exports.UpdateFamilyMemberRequest,
            responseType: exports.UpdateFamilyMemberResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'RemoveFamilyMember',
            requestType: exports.RemoveFamilyMemberRequest,
            responseType: exports.RemoveFamilyMemberResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'ImpersonateUser',
            requestType: exports.ImpersonateUserRequest,
            responseType: exports.ImpersonateUserResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'CreateManagedUser',
            requestType: exports.CreateManagedUserRequest,
            responseType: exports.CreateManagedUserResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'MergeFamilyMembers',
            requestType: exports.MergeFamilyMembersRequest,
            responseType: exports.MergeFamilyMembersResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'SwitchToMergedUser',
            requestType: exports.SwitchToMergedUserRequest,
            responseType: exports.SwitchToMergedUserResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Looks up family members.
     */
    get(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Looks up a list of the family invites for the caller.
     */
    getFamilyInvites(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Looks up family address. This is the family admin address.
     */
    getFamilyAddress(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Invites a new member to join the family.
     */
    inviteMember(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Approves invite for the member to join the family.
     */
    approveFamilyInvite(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Removes invite for the member to join the family.
     */
    unInviteMember(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Invites a new family member to join.
     */
    joinFamily(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Reject Family Invite
     */
    rejectFamilyInvite(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[7],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Updates a family member.
     */
    updateFamilyMember(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[8],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Removes a family member.
     */
    removeFamilyMember(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[9],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Allows a sponsor to impersonate sponsee. The level of the access token will
     * match the authenticated sponsor's auth level.
     */
    impersonateUser(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[10],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * A sponsor can create a managed user without a device.
     */
    createManagedUser(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[11],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * A sponsor can merge a managed user with another sponsee.
     */
    mergeFamilyMembers(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[12],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Login to the formerly managed user account from the user account it was
     * merged with for graduation.
     */
    switchToMergedUser(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[13],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.FamilyServiceClient = FamilyServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=family-service.js.map